module.exports = __webpack_public_path__ + "img/d03.2664fa0c.jpg";